<template>
  <div class="multi-select-component">
    <div
      v-if="!configuration['label-inside']"
      class="label outside"
      :class="{'side': configuration['label-side']}"
    >{{label}}</div>
    <multiselect
      :class="[mode, configuration['allow-empty'] ? 'radio-btns':'not-radio-btns']"
      v-model="internalValue"
      :options="_options"
      v-bind="configuration"
      :disabled="disabled"
      :maxHeight="180"
    >
      <template slot="option" slot-scope="props">
        <div class="option-item">
          <div class="selected-option-mark"></div>
          <div class="icon-space"></div>
          <template v-if="props.option.value.rows">
            <slot name="customOption" v-bind:props="props"></slot>
          </template>
          <template v-else>
            <div class="text">{{props.option.label}}</div>
          </template>
        </div>
      </template>
      <template
        v-if="configuration['label-inside'] || mode==='multiple'"
        slot="selection"
        slot-scope="{ values }"
      >
        <template v-if="configuration['label-inside']">
          <span class="label inside">{{label}}:</span>
        </template>
        <span
          v-if="mode==='multiple' && values.length"
          class="multiselect__single"
        >
          <template v-if="configuration.showMulipleValues">{{values.map((d)=>d.label || d.value).join(', ')}}</template>
          <template v-else>{{ values.length }} options selected</template>
        </span>
      </template>
      <template v-if="usesPlot" slot="singleLabel" slot-scope="props">
        <slot name="customSingleLabel" v-bind:props="props"></slot>
      </template>
      <template v-if="usesPlot" slot="afterList">
        <slot name="customAfterList"></slot>
      </template>
      <template slot="noOptions">
        <span>{{noOptions}}</span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'MultiSelectComponent',
  components: {
    Multiselect
  },
  props: {
    label: {
      type: String,
      required: false
    },
    value: {
      // type: Object,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    mode: {
      type: String, //multiple or single
      required: true
    },
    configurationOptions: {
      type: Object,
      required: false
    },
    alwaysArray:{
      type: Boolean,
      required: false,
      default: false
    },
    disabled:{
      type: Boolean,
      required: false,
      default: false
    },
    noOptions:{
      type: String,
      required: false
    },
    height: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      defaultGeneralConfiguration: {
        'allow-empty': true,
        'label': 'label',
        'label-inside': false,
        'label-side': false,
        'placeholder': 'Select',
        'searchable': false,
        'show-labels': false,
        'track-by':'value'
      },
      defaultModeConfiguration: {
        'single': {
          'close-on-select': true
        },
        'multiple': {
          'close-on-select': false,
          'multiple': true
        }
      }
    }
  },
  computed: {
    defaultConfiguration () {
      return Object.assign({}, this.defaultGeneralConfiguration, this.defaultModeConfiguration[this.mode])
    },
    configuration () {
      return Object.assign({}, this.defaultConfiguration, this.configurationOptions)
    },
    usesPlot () {
      return this._options[0] && this._options[0].value.rows
    },
    internalValue: {
      get() {
        if(this.mode==='multiple'){
          // bastante feo, pero creo que hace lo que debe...
          if(!this.value) return this.value
          let values = this.value
          if( !Array.isArray(this.value) ) values = [this.value]
          let currentValues = values.map((v)=>(v && v.value!==undefined)?v.value:v)
          return this._options.filter((o)=>currentValues.indexOf(o.value)>=0)
        } else {
          let currentValue = this.value && this.value.value || this.value //por si el this.value fuera {value:xx,label:xx}
          if( Array.isArray(currentValue) ) currentValue = currentValue[0]
          return this._options.find((o)=>{ 
            return o.value === currentValue || 
            ( o.value.id && currentValue && currentValue.id && o.value.id === currentValue.id) ||
            ( o.value.name && currentValue && currentValue.name && o.value.name === currentValue.name) //BASURA: los type distribution no llevan id...
          }) //
        }
      },
      set(val){
        if(this.mode==='multiple'){
          this.$emit('input', val.map((v)=>v.value) )
        } else {
          //WTF, antes funcionaba sin [], pero parece que ahora debe ser ARRAY siempre inculso en "single"
          if(this.alwaysArray) this.$emit('input', [val?val.value:val] )
          else this.$emit('input', val?val.value:val )
        }
      }
    },
    _options () {
      return this.options.map((v)=>{
        if(v && v.value!==undefined) return v
        return {
          label: v?v:'None',
          value: v
        }
      })
    }
  // },
  // methods: {
    // apply () {
    //   // this.value = this.internalValue
    //   this.$emit('input', this.internalValue)
    // }
  // },
  // watch: {
  //   value(){
  //     this.internalValue = this.value
  //   }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="stylus" scoped>
$multi-select-height = 32px
$multi-select-color = $cloud-burst

.multi-select-component
  // width: 100%; //para que "corte" bien (NO!, estropea el "slices panel"...)
  .label
    color: $shuttle-gray
    m-font-size(12, 14)
    text-transform: capitalize

    &.inside
      margin-right: 5px
      white-space: nowrap

    &.outside
      margin-bottom: 5px

      &.side
        margin-bottom: 0
        margin-right: 10px

  .multiselect
    color: $multi-select-color
    cursor: pointer
    height: $multi-select-height
    min-height: $multi-select-height
    // width: 100%
    min-width: 80px

    &.multiselect--above
      >>> .multiselect__content-wrapper
        border-radius: 5px 5px 0 0

    .option-item
      .icon-space
        min-width 14px
        min-height 14px
        max-width 14px
        max-height 14px
    &.single
      &.radio-btns
        .option-item
          .icon-space
            m-icon("radio-empty", 14)
            margin-right: 5px

        >>> .multiselect__option--selected
          .option-item
            .icon-space
              m-icon("radio-checked", 14)

      &.not-radio-btns
        >>> .multiselect__option--selected
          .option-item
            .selected-option-mark
              &:before
                background-color: $radical-red
                content: ""
                height: 100%
                left: 0
                position: absolute
                top: 0
                width: 4px

    &.multiple
      .option-item
        .icon-space
          m-icon("checkbox-empty", 14)
          margin-right: 5px
         

      >>> .multiselect__option--selected
        .option-item
          .icon-space
            m-icon("checkbox-checked", 14)

    >>> .multiselect__select
      height: $multi-select-height
      margin: 0
      padding: 0
      position: absolute
      right: 0
      top: 0
      width: @height
      background none
      &:before
        display: none

      &:after
        content: ""
        display: block
        left: 50%
        m-icon("dropdown-chevron", 10)
        position: absolute
        top: 50%
        transform: translate(-50%, -50%)

    >>> .multiselect__element
      &:not(:first-child)
        border-top: 1px solid $mystic

    >>> .multiselect__option
      align-items: center
      display: flex
      m-font-size(14, 18)
      min-height: $multi-select-height
      padding: 10px
      white-space: normal

      &.multiselect__option--disabled
        background-color: #fff !important
        color: rgba($cloud-burst, 0.1) !important
        cursor: default !important
        pointer-events: all !important

    >>> .multiselect__tags
      align-items: center
      border-color: $mystic
      display: flex
      m-font-size(14, 18)
      min-height: $multi-select-height
      padding: 0
      padding-left: 10px
      padding-right: 32px

      .multiselect__placeholder
        margin: 0
        padding: 0

      .multiselect__single
        m-ellipsis(100%)
        display: block
        margin: 0
        padding: 0

        .name
          padding-left: 10px

    >>> .multiselect__content-wrapper
      border-radius: 0 0 5px 5px
      box-shadow: 5px 5px 20px rgba($lynch, 0.25)

      .after-list-container
        align-items: center
        display: flex
        margin: 10px
        min-height: $multi-select-height

      .multiselect__content
        width: 100%

        .option-item
          align-items: center
          display: flex
          width: 100%

          .text
            //m-ellipsis(100%)
            max-width: 100%
            overflow: hidden
            word-break: break-word
            white-space: pre-wrap
            margin-top: -0.1em

    >>> .multiselect__option--selected
      background: none
      color: $multi-select-color
      font-weight: $fw-regular

    >>> .multiselect__option--highlight
      background: rgba($mystic, 0.5)
      color: $multi-select-color
</style>